import { useEffect, useState } from "react";
var useWindowSize = function (delay) {
    if (delay === void 0) { delay = 0; }
    var _a = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    }), windowSize = _a[0], setWindowSize = _a[1];
    useEffect(function () {
        var debounce = function (callback, delay) {
            var timer;
            return function debouncedFunc() {
                clearTimeout(timer);
                timer = setTimeout(callback, delay);
            };
        };
        var handleResize = debounce(function () {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }, delay);
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, [delay]);
    return windowSize;
};
export default useWindowSize;
